import { initContract } from "@ts-rest/core";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    chartOfAccountsTemplateApplyEventDetailSchema,
    chartOfAccountsTemplateApplyEventPathParamsSchema,
    coaApplyUndoEligibilitySchema,
    coaApplyUndoResponseSchema,
    coaTemplateApplyUndoBodySchema,
} from "@common/schemas/domains/accounting/chart-of-accounts-template-apply-event.schema";

const c = initContract();

export const chartOfAccountsTemplateApplyEventContract = c.router(
    {
        getApplyEvent: {
            method: "GET",
            path: "/:workspaceId/:eventId",
            pathParams: chartOfAccountsTemplateApplyEventPathParamsSchema,
            responses: {
                200: chartOfAccountsTemplateApplyEventDetailSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        getUndoEligibility: {
            method: "GET",
            path: "/:workspaceId/:eventId/undo-eligibility",
            pathParams: chartOfAccountsTemplateApplyEventPathParamsSchema,
            responses: {
                200: coaApplyUndoEligibilitySchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        undoApplyEvent: {
            method: "POST",
            path: "/:workspaceId/:eventId/undo",
            pathParams: chartOfAccountsTemplateApplyEventPathParamsSchema,
            body: coaTemplateApplyUndoBodySchema,
            responses: {
                200: coaApplyUndoResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
                409: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/accounting/coa-template-apply-events",
    },
);
